import { Button, Heading, Span } from "@icg360/design-system";

import { Stack } from "components/common/stack";
import { type KeystoneReferral } from "data/keystone-api-mapping";
import { checkForNaStringValue, trackEvent } from "utils";

import { WriteOutIcon } from "../write-out-icon";
import styles from "./ineligible-write-out-entry.module.scss";

export const IneligibleWriteOutEntry = ({
  referral,
  primaryIneligible,
  showGallery,
}: {
  referral: KeystoneReferral;
  primaryIneligible: boolean;
  showGallery: () => void;
}) => {
  const {
    category,
    groupedIssueStatements,
    groupedReasonings,
    locationDetail,
    inspectionReviewAssetIds,
    issueStatement,
    reasoning,
  } = referral;

  let writeOutHeading = checkForNaStringValue(issueStatement ?? "");
  if (groupedIssueStatements?.length) {
    writeOutHeading = "Roof - Multiple issues";
  }
  const reasoningDisplay = checkForNaStringValue(reasoning ?? "");
  let reasonings: string[] = [];
  if (groupedReasonings?.length) {
    reasonings = groupedReasonings;
  } else if (reasoningDisplay) {
    reasonings = new Array(reasoningDisplay);
  }
  const locationDisplay = checkForNaStringValue(locationDetail ?? "");

  return (
    <div className={styles.writeOut}>
      <div
        className={
          primaryIneligible
            ? styles.ineligibleWriteOutIcon
            : styles.writeOutIcon
        }
      >
        <WriteOutIcon category={category} />
      </div>
      <Stack gap="sm">
        {writeOutHeading ? (
          <Heading size="sm">{writeOutHeading}</Heading>
        ) : null}

        {reasonings.map((reasoning, idx) => (
          <Span key={idx} color="quiet" size="sm">
            {reasoning}
          </Span>
        ))}

        <div className={styles.twoEntryLine}>
          {locationDisplay ? (
            <div>
              <Span bold>Location: </Span>
              <Span>{locationDisplay}</Span>
            </div>
          ) : null}
          {inspectionReviewAssetIds?.length ? (
            <Span bold>
              <Button
                size="xs"
                leadingIcon="FileJpg"
                appearance="link"
                data-testid="ineligible-write-out-photos-button"
                onPress={() => {
                  trackEvent(
                    "Inspection ineligible write-outs: Photo gallery opened",
                    {
                      numberOfPhotos: inspectionReviewAssetIds.length,
                      referral,
                    }
                  );
                  showGallery();
                }}
              >
                {inspectionReviewAssetIds.length} photo
                {inspectionReviewAssetIds.length > 1 ? "s" : ""}
              </Button>
            </Span>
          ) : null}
        </div>
      </Stack>
    </div>
  );
};
